module.exports = __webpack_public_path__ + "media/images/design/images/icon_tw-ad0ebee061465ad62ff5383b3fa8c464.jpg";